import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { CRMOverview } from './CRMOverview';
import { CRMDetails } from './components/CRMDetails';
import { CRMCalendar } from './components/CRMCalendar';

const CRMPage: React.FC = () => {
    const [activeTab, setActiveTab] = useState(0);
    const location = useLocation();
    const navigate = useNavigate();

    // Update active tab based on current route
    React.useEffect(() => {
        if (location.pathname.includes('/calendar')) {
            setActiveTab(1);
        } else if (!location.pathname.includes('/crm/')) {
            setActiveTab(0);
        }
    }, [location]);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
        if (newValue === 0) {
            navigate('/crm');
        } else if (newValue === 1) {
            navigate('/crm/calendar');
        }
    };

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={activeTab} onChange={handleTabChange}>
                    <Tab label="CRM OVERVIEW" />
                    <Tab label="CALENDAR" />
                </Tabs>
            </Box>

            <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                <Routes>
                    <Route index element={<CRMOverview />} />
                    <Route path=":id" element={<CRMDetails />} />
                    <Route path="calendar" element={<CRMCalendar />} />
                </Routes>
            </Box>
        </Box>
    );
};

export default CRMPage; 